// import React from "react";
// import { Helmet } from "react-helmet-async";

// const SEO = ({ title, description, keywords, canonical }) => {
//   return (
//     <Helmet>
//       <title>{title || "best cupping therapy tools ,authentic cupping supplies | shopeindia "}</title>
//       <meta name="description" content={description || "ShopeIndia default description"} />
//       <meta name="keywords" content={keywords || "shopping, online, shopindia"} />
//       <link rel="canonical" href={canonical || window.location.href} />
//     </Helmet>
//   );
// };

// export default SEO;


import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEO;